// removed by extract-text-webpack-plugin
module.exports = {"switch_block":"switch_block"};


//////////////////
// WEBPACK FOOTER
// ./src/view/screens/Project/components/SwitchBlock/style.scss
// module id = 1359
// module chunks = 0